import { connect } from 'react-redux';
import {AmbryKeyDialog} from "../components/AmbryKeyDialog.jsx";
import * as actions from '../actions/AmbryKeysActions'

const mapStateToProps = state => {
    return {
        show: state.ambryKey.show,
        error: state.ambryKey.error,
        clientId: state.ambryKey.clientId,
        clientSecret: state.ambryKey.clientSecret,
        hostAddress: state.ambryKey.hostAddress,
        grantType: state.ambryKey.grantType,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onHide: () => {
            dispatch(actions.showDialog(false));
        },
        onSave: () => {
            dispatch(actions.saveData());
            dispatch(actions.showDialog(false));
        },
        onDataChange: (field, value) => {dispatch(actions.updateData(field, value))},
        onLoad: () => {dispatch(actions.loadData())}
    }
};

const AmbryKeyDialogController = connect(
    mapStateToProps,
    mapDispatchToProps
)(AmbryKeyDialog);

export default AmbryKeyDialogController;